import React, { useState, useEffect } from "react";
import InputLabel from "../../../../Components/FloatingLabel/FloatingLabel";
import { Row, Col, Select, message } from "antd";
import TaxCollectionDetailTable from "./TaxCollectionDetailsTable";
import GeneratePH10Modal from "../GenerateChallanModal/GenerateChallanModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as taxCollectionActions from "../../../../actionCreators/TaxCollection";
import PropTypes from "prop-types";
import "./style/taxCollections.css";
import { getFiscalYear } from "../../../../utils/dateTime";

const { Option } = Select;
const generateDropdownValues = (taxCreatedAt) => {
  let year = new Date(taxCreatedAt)?.getFullYear();
  const dropDownVal = [];
  let ids = 0;
  while (year <= new Date().getFullYear()) {
    dropDownVal.push({
      id: ids,
      year: +year + 1,
      filledYear: transformYear(year + 1),
    });
    ids++;
    year++;
  }
  return dropDownVal;
};
const transformYear = (year) => `${year - 1} - ${+String(year).slice(-2)}`;

const TaxCollectionTabContent = ({
  propertyId,
  propertyData,
  taxCreatedAt,
  getTaxDetailsOfPropertyBasedOnYear,
  taxDetailsOfPropertyBasedOnYear,
  generateChallan,
  generateChallanAction,
}) => {
  const [dropdownValues, setDropdownValues] = useState([]);
  const currentYear = getFiscalYear();
  const [fiscalYearActive, setFiscalYearActive] = useState(true);
  const [selectedRow, setSelectedRow] = useState();
  const [fiscalYear, setFiscalYear] = useState();
  React.useEffect(() => {
    if (taxCreatedAt) {
      setDropdownValues(generateDropdownValues(taxCreatedAt));
    }
  }, [taxCreatedAt]);

  React.useEffect(() => {
    setFiscalYear(dropdownValues[dropdownValues.length - 1]);
  }, [dropdownValues]);
  useEffect(() => {
    if (selectedRow) {
      setGenerateModalVisible(true);
    }
  }, [selectedRow]);
  const [generateModalVisible, setGenerateModalVisible] = useState(false);
  React.useEffect(() => {
    getTaxDetailsOfPropertyBasedOnYear({
      propertyId,
      fiscalYear: currentYear,
    });
  }, []);
  React.useEffect(() => {
    if (generateChallan?.error) {
      message.error(generateChallan?.error);
    }
  }, [generateChallan]);
  React.useEffect(() => {
    if (generateChallan?.data?.message) {
      // message.success("Challan Generated");
      setGenerateModalVisible(false);
      getTaxDetailsOfPropertyBasedOnYear({
        propertyId,
        fiscalYear: currentYear,
      });
    }
  }, [generateChallan?.data]);

  const onDropDownChange = (val) => {
    const valObject = dropdownValues[val];
    setFiscalYear({ ...valObject });
    getTaxDetailsOfPropertyBasedOnYear({
      propertyId,
      fiscalYear: valObject.year,
    });
  };
  const generateModalSubmitHandler = (values) => {
    const objToSendGenerateChallan = {
      annual_tax: selectedRow?.annualTax,
      arrears: values?.arrears,
      surcharge: values?.surcharge,
      type: selectedRow?.type,
      property_id: +propertyId,
      taxes_id: selectedRow?.taxCollectionId,
      property_data: taxDetailsOfPropertyBasedOnYear?.data[0]?.property_data,
    };
    generateChallanAction(objToSendGenerateChallan);
    // setSelectedRow(null);
  };
  const generateModalCancelHandler = () => {
    setGenerateModalVisible(false);
    setSelectedRow(null);
  };
  const getDifferenceValue = () => {
    const data = taxDetailsOfPropertyBasedOnYear?.data;
    return data[data?.length - 2]?.differencePayable*-1;
  };
  return (
    <>
      <Row gutter={[0, 16]}>
        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
          {fiscalYear?.filledYear && (
            <div
              onFocus={() => setFiscalYearActive(true)}
              onBlur={() => setFiscalYearActive(false)}
              //className="dropdowns"
            >
              <InputLabel
                value={fiscalYear?.filledYear}
                labelText="Fiscal Year"
                active={fiscalYearActive}
              >
                <Select
                  onChange={onDropDownChange}
                  defaultValue={
                    dropdownValues[dropdownValues?.length - 1]?.filledYear
                  }
                  size="large"
                  disabled={taxDetailsOfPropertyBasedOnYear?.loading}
                >
                  {dropdownValues?.map((item) => (
                    <Option value={item.id}>{item?.filledYear}</Option>
                  ))}
                </Select>
              </InputLabel>
            </div>
          )}
        </Col>
        <Col xl={24}>
          <TaxCollectionDetailTable
            taxDetailsOfPropertyBasedOnYear={taxDetailsOfPropertyBasedOnYear}
            propertyData={propertyData}
            setSelectedRow={setSelectedRow}
            isOld={fiscalYear?.year < currentYear + 1}
          />
        </Col>
        <GeneratePH10Modal
          visible={generateModalVisible}
          initialPayableValue={selectedRow?.annualTax}
          onModalSubmit={generateModalSubmitHandler}
          initialArrearsValue={selectedRow?.arrears}
          onModalCancel={generateModalCancelHandler}
          loading={generateChallan?.loading}
        />
        {taxDetailsOfPropertyBasedOnYear?.data?.length > 1 && (
          <>
            {" "}
            Difference in old and new total payable is &nbsp;{" "}
            <span className="difference-amount">
              Rs.
              {getDifferenceValue()}.
            </span>{" "}
            &nbsp;
            {/* <span className="difference-challan-button">
              {" "}
              Generate Difference Challan.
            </span> */}
          </>
        )}
      </Row>
    </>
  );
};

const mapStateToProps = ({
  taxCollection: { taxDetailsOfPropertyBasedOnYear, generateChallan },
}) => ({
  taxDetailsOfPropertyBasedOnYear,
  generateChallan,
});

const mapDispatchToProps = (dispatch) => ({
  getTaxDetailsOfPropertyBasedOnYear: bindActionCreators(
    taxCollectionActions.getTaxDetailsOfPropertyBasedOnYear,
    dispatch
  ),
  generateChallanAction: bindActionCreators(
    taxCollectionActions.generateChallan,
    dispatch
  ),
});

TaxCollectionTabContent.propTypes = {
  getTaxDetailsOfPropertyBasedOnYear: PropTypes.func.isRequired,
  propertyId: PropTypes.number.isRequired,
  taxDetailsOfPropertyBasedOnYear: PropTypes.array.isRequired,
  generateChallan: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaxCollectionTabContent);
